import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

const SupplyChainSoftwareDevServices = () => {
    return (
        <div className="py-12 sm:py-16 md:py-20 lg:py-[100px]">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="row grid md:grid-cols-12 justify-center">
                    <div className=" md:col-span-4">
                        <div className="text-start sticky sticky-list">
                            <h2 className="text-primary_one font-bold mb-2.5">Supply Chain Software Development Services</h2>

                            <div>
                                <Link href="/contact-us" className="btn btn-primary">
                                    {'Ready to Streamline Your SCM Process?'}
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="md:col-span-8">
                        <div className="sticky-content">
                            <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-3 gap-7 mb-7">
                                <div className="flex flex-col gap-[9px] card p-5 bg-white dark:bg-black rounded-10 border">
                                    <div className="voice-generator-box">
                                        <Image
                                            src="/img/moweb-supply-chain-icons/ic-supply-chain-inventory.svg"
                                            width={36}
                                            height={36}
                                            alt="supply-chain-inventory"
                                        />
                                    </div>
                                    <p className="text-primary_one font-bold mb-0">Supply Chain Inventory Management</p>
                                    <p className="text-secondary mb-0 fs-md">
                                        Track, forecast, and optimize inventory across multiple locations in real-time, so you
                                        never overstock or run out.
                                    </p>
                                </div>
                                <div className="flex flex-col gap-[9px] card p-5 bg-white dark:bg-black rounded-10 border">
                                    <div className="voice-generator-box">
                                        <Image
                                            src="/img/moweb-supply-chain-icons/ic-supply-chain-risk-management.svg"
                                            width={36}
                                            height={36}
                                            alt="supply-chain-risk-management"
                                        />
                                    </div>

                                    <p className="text-primary_one font-bold mb-0">Supply Chain Risk Management</p>
                                    <p className="text-secondary mb-0 fs-md">
                                        Identify, assess, and mitigate operational risks proactively using data-backed alerts and
                                        scenario-based simulations.
                                    </p>
                                </div>
                                <div className="flex flex-col gap-[9px] card p-5 bg-white dark:bg-black rounded-10 border">
                                    <div className="voice-generator-box">
                                        <Image
                                            src="/img/moweb-supply-chain-icons/ic-optimizing-routes.svg"
                                            width={36}
                                            height={36}
                                            alt="optimizing-routes"
                                        />
                                    </div>

                                    <p className="text-primary_one font-bold mb-0">
                                        Optimizing Routes Using Artificial Intelligence
                                    </p>
                                    <p className="text-secondary mb-0 fs-md">
                                        Cut delivery times and fuel costs with AI that finds the most efficient, traffic-aware,
                                        and cost-effective routes in seconds.
                                    </p>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-3 gap-7 mb-7">
                                <div className="flex flex-col gap-[9px] card p-5 bg-white dark:bg-black rounded-10 border">
                                    <div className="voice-generator-box">
                                        <Image
                                            src="/img/moweb-supply-chain-icons/ic-ai-powered-inventory.svg"
                                            width={36}
                                            height={36}
                                            alt="ai-powered-inventory.svg"
                                        />
                                    </div>

                                    <p className="text-primary_one font-bold mb-0">AI-Powered Inventory Management Software</p>
                                    <p className="text-secondary mb-0 fs-md">
                                        Use predictive analytics to automate reordering, reduce carrying costs, and improve
                                        fulfillment accuracy without manual guesswork.
                                    </p>
                                </div>
                                <div className="flex flex-col gap-[9px] card p-5 bg-white dark:bg-black rounded-10 border">
                                    <div className="voice-generator-box">
                                        <Image
                                            src="/img/moweb-supply-chain-icons/ic-smart-warehouse.svg"
                                            width={36}
                                            height={36}
                                            alt="smart-warehouse"
                                        />
                                    </div>
                                    <p className="text-primary_one font-bold mb-0">Smart Warehouse Management</p>
                                    <p className="text-secondary mb-0 fs-md">
                                        Turn your warehouse into a smart, self-regulating hub with automated picking, inventory
                                        sync, and real-time location tracking.
                                    </p>
                                </div>
                                <div className="flex flex-col gap-[9px] card p-5 bg-white dark:bg-black rounded-10 border">
                                    <div className="voice-generator-box">
                                        <Image
                                            src="/img/moweb-supply-chain-icons/ic-order-management.svg"
                                            width={36}
                                            height={36}
                                            alt="order-management"
                                        />
                                    </div>
                                    <p className="text-primary_one font-bold mb-0">Order Management System</p>
                                    <p className="text-secondary mb-0 fs-md">
                                        Centralize orders from all channels, automate processing, and deliver a seamless
                                        fulfillment experience from cart to doorstep.
                                    </p>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-3 gap-7">
                                <div className="flex flex-col gap-[9px] card p-5 bg-white dark:bg-black rounded-10 border">
                                    <div className="voice-generator-box">
                                        <Image
                                            src="/img/moweb-supply-chain-icons/ic-shipping-and-logistics.svg"
                                            width={36}
                                            height={36}
                                            alt="shipping-and-logistics"
                                        />
                                    </div>
                                    <p className="text-primary_one font-bold mb-0">Shipping and Logistics Software Development</p>
                                    <p className="text-secondary mb-0 fs-md">
                                        Build logistics systems that connect with carriers, track shipments, and streamline
                                        cross-border compliance in real-time.
                                    </p>
                                </div>
                                <div className="flex flex-col gap-[9px] card p-5 bg-white dark:bg-black rounded-10 border">
                                    <div className="voice-generator-box">
                                        <Image
                                            src="/img/moweb-supply-chain-icons/ic-edi.svg"
                                            width={36}
                                            height={36}
                                            alt="EDI Software System"
                                        />
                                    </div>

                                    <p className="text-primary_one font-bold mb-0">EDI Software System</p>
                                    <p className="text-secondary mb-0 fs-md">
                                        Simplify B2B transactions and ensure data integrity with custom-built EDI software that
                                        integrates across vendors and formats.
                                    </p>
                                </div>
                                <div className="flex flex-col gap-[9px] card p-5 bg-white dark:bg-black rounded-10 border">
                                    <div className="voice-generator-box">
                                        <Image
                                            src="/img/moweb-supply-chain-icons/ic-freight-management.svg"
                                            width={36}
                                            height={36}
                                            alt="freight-management"
                                        />
                                    </div>

                                    <p className="text-primary_one font-bold mb-0">Freight Management Software</p>
                                    <p className="text-secondary mb-0 fs-md">
                                        Gain total visibility over freight costs, lane performance, and delivery KPIs—while
                                        automating dispatch and invoice reconciliation.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default SupplyChainSoftwareDevServices;
